package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.FormatListNumberedW500Rounded: ImageVector
    get() {
        if (_formatListNumberedW500Rounded != null) {
            return _formatListNumberedW500Rounded!!
        }
        _formatListNumberedW500Rounded = Builder(name = "FormatListNumberedW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(150.0f, 888.13f)
                quadToRelative(-14.04f, 0.0f, -23.21f, -9.16f)
                quadToRelative(-9.18f, -9.16f, -9.18f, -23.18f)
                quadToRelative(0.0f, -14.01f, 9.18f, -23.22f)
                quadToRelative(9.17f, -9.22f, 23.21f, -9.22f)
                horizontalLineToRelative(67.61f)
                verticalLineToRelative(-27.61f)
                horizontalLineToRelative(-30.0f)
                quadToRelative(-13.0f, 0.0f, -21.5f, -8.5f)
                reflectiveQuadToRelative(-8.5f, -21.5f)
                quadToRelative(0.0f, -13.0f, 8.5f, -21.5f)
                reflectiveQuadToRelative(21.5f, -8.5f)
                horizontalLineToRelative(30.0f)
                verticalLineToRelative(-27.61f)
                lineTo(150.0f, 708.13f)
                quadToRelative(-14.04f, 0.0f, -23.21f, -9.16f)
                quadToRelative(-9.18f, -9.16f, -9.18f, -23.18f)
                quadToRelative(0.0f, -14.01f, 9.18f, -23.22f)
                quadToRelative(9.17f, -9.22f, 23.21f, -9.22f)
                horizontalLineToRelative(90.0f)
                quadToRelative(18.02f, 0.0f, 30.2f, 12.19f)
                quadToRelative(12.19f, 12.18f, 12.19f, 30.2f)
                verticalLineToRelative(37.61f)
                quadToRelative(0.0f, 18.01f, -12.19f, 30.2f)
                quadToRelative(-12.18f, 12.19f, -30.2f, 12.19f)
                quadToRelative(18.02f, 0.0f, 30.2f, 12.19f)
                quadToRelative(12.19f, 12.18f, 12.19f, 30.2f)
                verticalLineToRelative(37.61f)
                quadToRelative(0.0f, 18.02f, -12.19f, 30.2f)
                quadToRelative(-12.18f, 12.19f, -30.2f, 12.19f)
                horizontalLineToRelative(-90.0f)
                close()
                moveTo(151.67f, 602.39f)
                quadToRelative(-14.76f, 0.0f, -24.41f, -9.65f)
                reflectiveQuadToRelative(-9.65f, -24.41f)
                verticalLineToRelative(-75.94f)
                quadToRelative(0.0f, -18.01f, 12.19f, -30.2f)
                quadTo(141.98f, 450.0f, 160.0f, 450.0f)
                horizontalLineToRelative(57.61f)
                verticalLineToRelative(-27.61f)
                lineTo(150.0f, 422.39f)
                quadToRelative(-14.04f, 0.0f, -23.21f, -9.16f)
                quadToRelative(-9.18f, -9.16f, -9.18f, -23.17f)
                quadToRelative(0.0f, -14.02f, 9.18f, -23.23f)
                quadToRelative(9.17f, -9.22f, 23.21f, -9.22f)
                horizontalLineToRelative(90.0f)
                quadToRelative(18.02f, 0.0f, 30.2f, 12.19f)
                quadToRelative(12.19f, 12.18f, 12.19f, 30.2f)
                verticalLineToRelative(67.61f)
                quadToRelative(0.0f, 18.01f, -12.19f, 30.2f)
                quadTo(258.02f, 510.0f, 240.0f, 510.0f)
                horizontalLineToRelative(-57.61f)
                verticalLineToRelative(27.61f)
                lineTo(250.0f, 537.61f)
                quadToRelative(14.04f, 0.0f, 23.21f, 9.16f)
                quadToRelative(9.18f, 9.16f, 9.18f, 23.17f)
                quadToRelative(0.0f, 14.02f, -9.18f, 23.23f)
                quadToRelative(-9.17f, 9.22f, -23.21f, 9.22f)
                horizontalLineToRelative(-98.33f)
                close()
                moveTo(186.83f, 307.47f)
                quadToRelative(-9.22f, -9.17f, -9.22f, -23.21f)
                verticalLineToRelative(-150.0f)
                lineTo(148.8f, 134.26f)
                quadToRelative(-13.23f, 0.0f, -22.21f, -8.98f)
                reflectiveQuadToRelative(-8.98f, -22.21f)
                quadToRelative(0.0f, -13.24f, 8.98f, -22.22f)
                quadToRelative(8.98f, -8.98f, 22.21f, -8.98f)
                horizontalLineToRelative(59.53f)
                quadToRelative(14.76f, 0.0f, 24.41f, 9.65f)
                reflectiveQuadToRelative(9.65f, 24.41f)
                verticalLineToRelative(178.33f)
                quadToRelative(0.0f, 14.04f, -9.16f, 23.21f)
                quadToRelative(-9.16f, 9.18f, -23.17f, 9.18f)
                quadToRelative(-14.02f, 0.0f, -23.23f, -9.18f)
                close()
                moveTo(407.89f, 765.5f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                reflectiveQuadToRelative(13.18f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.32f, -13.17f)
                horizontalLineToRelative(394.74f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(407.89f, 765.5f)
                close()
                moveTo(407.89f, 525.5f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                reflectiveQuadToRelative(13.18f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.32f, -13.17f)
                horizontalLineToRelative(394.74f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(407.89f, 525.5f)
                close()
                moveTo(407.89f, 285.5f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                reflectiveQuadToRelative(13.18f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.32f, -13.17f)
                horizontalLineToRelative(394.74f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(407.89f, 285.5f)
                close()
            }
        }
        .build()
        return _formatListNumberedW500Rounded!!
    }

private var _formatListNumberedW500Rounded: ImageVector? = null
